import { Col, FormGroup, FormParagraph, Row } from '@ksyos/design-system';
import { useId } from 'react';
import type { IOrganizationGeneralSettings } from '@common/validation/organization';
import type { ValidationErrors } from '@frontend/utils/validation';
import { getSelectedLanguage } from '@frontend/translate';
import { InputText } from '../../../userDataManagement/InputText';

type HouseNumberFormGroupProps = {
    canEdit: boolean;
    errors: ValidationErrors;
    organization: IOrganizationGeneralSettings;
};

export function HouseNumberFormGroup({
    canEdit,
    errors,
    organization: { houseNumber, houseNumberSuffix },
}: Readonly<HouseNumberFormGroupProps>) {
    const translate = getSelectedLanguage();
    const id = useId();

    return (
        <FormGroup
            htmlFor={canEdit ? id : undefined}
            label={translate.common.houseNumber}
        >
            {!canEdit && (
                <FormParagraph>{houseNumber ? `${houseNumber} ${houseNumberSuffix ?? ''}` : '-'}</FormParagraph>
            )}

            {canEdit && (
                <Row columnGap={[2, 4]}>
                    <Col span={6}>
                        <InputText
                            error={errors.get('houseNumber')}
                            fieldKey="houseNumber"
                            id={id}
                            nullable
                            placeholder={translate.common.houseNumber}
                        />
                    </Col>
                    <Col span={6}>
                        <InputText
                            error={errors.get('houseNumberSuffix')}
                            fieldKey="houseNumberSuffix"
                            nullable
                            placeholder={translate.common.suffix}
                        />
                    </Col>
                </Row>
            )}
        </FormGroup>
    );
}
